module.exports = __webpack_public_path__ + "83cbfd69a1fde13e4a475958c36f09c8.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/theater-2013.jpg
// module id = 675
// module chunks = 0